// frontend/src/components/FluxogramaModal.jsx

import React, { useState, useEffect } from 'react'; // <--- CORREÇÃO AQUI (Adicionado useEffect)

const API_BASE_URL = 'https://sigoapi.jhe-etes.com.br/api';

function FluxogramaModal({ isOpen, onClose, empreendimentoId, onSuccess }) {
  const [file, setFile] = useState(null);
  const [descricao, setDescricao] = useState('');
  const [uploading, setUploading] = useState(false);

  // Limpa os campos quando o modal abre
  useEffect(() => {
    if (isOpen) {
      setFile(null);
      setDescricao('');
      setUploading(false);
    }
  }, [isOpen]);

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file || !descricao) {
      alert("Por favor, selecione um arquivo e informe o motivo.");
      return;
    }

    setUploading(true);
    const formData = new FormData();
    formData.append('file', file);

    try {
      // 1. Upload do Arquivo
      const uploadRes = await fetch(`${API_BASE_URL}/upload`, { method: 'POST', body: formData });
      
      if (uploadRes.ok) {
        const uploadResult = await uploadRes.json();
        const newUrl = uploadResult.url;

        // 2. Atualiza Banco com Histórico
        const updatePayload = {
            fluxograma_url: newUrl,
            fluxograma_descricao: descricao,
            usuario_responsavel: "Admin" 
        };

        const updateRes = await fetch(`${API_BASE_URL}/empreendimentos/${empreendimentoId}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(updatePayload)
        });

        if (updateRes.ok) {
            alert("Fluxograma atualizado com sucesso!");
            onSuccess(); // Recarrega a tela principal
            onClose();   // Fecha o modal
        }
      }
    } catch (error) {
      console.error("Erro:", error);
      alert("Erro ao enviar arquivo.");
    } finally {
      setUploading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm animate-fadeIn">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md border border-gray-200 m-4">
        
        {/* Cabeçalho */}
        <div className="flex justify-between items-center p-5 border-b border-gray-100 bg-gray-50 rounded-t-xl">
          <h2 className="text-lg font-bold text-sabesp-blue flex items-center gap-2">
            📄 Atualizar Fluxograma
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 font-bold">✕</button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-5">
            
            {/* Área de Seleção de Arquivo */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Novo Arquivo</label>
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition-colors relative">
                    <input 
                        type="file" 
                        accept="image/*" 
                        onChange={handleFileChange}
                        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                    />
                    <div className="space-y-1">
                        <span className="text-2xl block">📤</span>
                        <span className="text-sm text-sabesp-cyan font-medium">Clique para selecionar</span>
                        <p className="text-xs text-gray-400">PNG, JPG ou JPEG</p>
                    </div>
                </div>
                {/* Feedback do arquivo selecionado */}
                {file && (
                    <div className="mt-2 text-xs flex items-center gap-2 text-green-600 bg-green-50 p-2 rounded border border-green-100">
                        <span>✅</span> Arquivo selecionado: <strong>{file.name}</strong>
                    </div>
                )}
            </div>

            {/* Campo de Descrição */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Motivo da Atualização <span className="text-red-500">*</span></label>
                <textarea 
                    rows="3" 
                    required 
                    placeholder="Ex: Revisão técnica da bomba, Atualização de layout..."
                    value={descricao} 
                    onChange={(e) => setDescricao(e.target.value)} 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sabesp-cyan outline-none text-sm resize-none" 
                />
            </div>

            {/* Botões de Ação */}
            <div className="pt-2 flex gap-3">
                <button type="button" onClick={onClose} className="flex-1 py-2.5 border border-gray-300 text-gray-600 rounded-lg hover:bg-gray-50 font-medium transition-colors">
                    Cancelar
                </button>
                <button 
                    type="submit" 
                    disabled={uploading || !file || !descricao}
                    className="flex-1 py-2.5 bg-sabesp-blue text-white font-bold rounded-lg hover:bg-blue-800 disabled:opacity-50 disabled:cursor-not-allowed transition-colors shadow-sm"
                >
                    {uploading ? 'Enviando...' : 'Confirmar Troca'}
                </button>
            </div>

        </form>
      </div>
    </div>
  );
}

export default FluxogramaModal;